module.exports = __webpack_public_path__ + "static/media/brunch2.4b84a492.png";